import { Link } from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocumentTitle';

function Cookies() {
  useDocumentTitle('Cookie Policy — MMI');

  return (
    <main className="legal-page">
      <article className="legal-document">
        <header className="legal-header">
          <p className="legal-updated">Last updated — May 2026</p>
          <h1>Cookie Policy</h1>
          <p className="legal-intro">
            Cookies are small text files stored on your device when you visit a website. They help
            sites remember preferences, keep sessions secure, and — on some sites — track you across
            the internet. MMI keeps it simple. Here is what we use and what we deliberately avoid.
          </p>
        </header>

        <section className="legal-section">
          <h2>Our approach</h2>
          <p>
            MMI is a builder of agentic AI and immersive systems — not an ad network. We do not use
            tracking cookies to follow you around the web or build advertising profiles. If we add
            analytics in the future, we will update this page first.
          </p>
        </section>

        <section className="legal-section">
          <h2>Types of cookies we may use</h2>
          <ul>
            <li>
              <strong>Essential / session</strong> — required for basic
              site function, such as remembering navigation state or security tokens during your visit.
              Without these, some features may not work correctly.
            </li>
            <li>
              <strong>Functional</strong> — optional preferences like
              dismissing a notice or remembering a display setting. These improve experience without
              identifying you across other sites.
            </li>
            <li>
              <strong>Analytics</strong> — if enabled, lightweight
              metrics to understand which pages are useful (e.g. visit counts, referrers). We prefer
              privacy-respecting, aggregated data — not individual behavioral dossiers.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Third-party cookies</h2>
          <p>
            We keep third-party cookies to a minimum. Our contact form uses{' '}
            <strong>Web3Forms</strong> to deliver messages — that
            service may set its own cookies when you submit the form. Embedded content (videos, maps,
            social widgets) may also set cookies if we add them in the future.
          </p>
          <p>
            We do not currently run third-party advertising or social tracking pixels on this site.
          </p>
        </section>

        <section className="legal-section">
          <h2>How to control cookies</h2>
          <p>You can manage cookies through your browser settings:</p>
          <ul>
            <li>Block all cookies (may break essential site features)</li>
            <li>Delete existing cookies for this domain</li>
            <li>Use private / incognito mode for a session without persistent storage</li>
          </ul>
          <p>
            Browser help pages: Chrome, Firefox, Safari, and Edge each document cookie controls under
            Privacy or Security settings.
          </p>
        </section>

        <section className="legal-section">
          <h2>Local storage</h2>
          <p>
            Some features may use local storage (similar to cookies but stored differently) for
            performance or UI state. The same principles apply — functional, minimal, no cross-site
            tracking.
          </p>
        </section>

        <section className="legal-section">
          <h2>Updates</h2>
          <p>
            If our stack changes — new analytics, embedded demos, or client portals — this policy will
            be updated to reflect what is actually in use.
          </p>
        </section>

        <div className="legal-contact">
          <p>
            Questions about cookies or privacy? Email{' '}
            <a href="mailto:hello@mmi.com">hello@mmi.com</a> or read our{' '}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </div>
      </article>
    </main>
  );
}

export default Cookies;
